<template>
    <div class="cs-userProfileComponent" >
      <DefaultComponent v-if="steps.isForm" :dictionary="dictionary" :isDefaultService="false" 
      :offer="offer" @closeComponent="$emit('closeComponent')" @goToNextStep="scrapeUser"
      :injectedError="error" :inputFieldValue="userInfo.username"
      ></DefaultComponent>
      <LoaderComponent v-if="steps.isLoading"></LoaderComponent>

      <div class="cs-userProfileComponent__profile cs-formBoxContainer " v-if="steps.isProfileInfo">
        <DefaultHeader :offer="offer" @closeComponent="$emit('closeComponent')"></DefaultHeader>
        <div class="cs-userProfileComponent__error cs-fieldErrorMessage" v-if="error.value">
          {{error.message}}
        </div>
        <div class="cs-userProfileComponent__info">
          <div class="cs-userProfileComponent__profilePicContainer">
            <img class="cs-userProfileComponent__profilePic" :src="userInfo.profilePic" alt="user profile picture">
          </div>
          <div class="cs-userProfileComponent__profileUsername">{{userInfo.username}}</div>
          <div class="cs-userProfileComponent__wrongUsernameQuestion" v-on:click="returnToFormStep()">{{dictionary.wrongUsernameChangeIt}}</div>
          <div class="cs-userProfileComponent__profileFollowers">
            <div class="cs-userProfileComponent__profileFollowersBefore">
            <div class="cs-userProfileComponent__profileFollowersLabel cs-userProfileComponent__profileFollowersBeforeLabel">{{dictionary.followersBefore}}</div>
            <div class="cs-userProfileComponent__profileFollowersCounter cs-userProfileComponent__profileFollowersBeforeCounter">{{userInfo.followers}}</div> 
          </div>
          <div class="cs-userProfileComponent__profileFollowersAfter">
            <div class="cs-userProfileComponent__profileFollowersLabel cs-userProfileComponent__profileFollowersAfterLabel">{{dictionary.followersAfter}}</div>
            <div class="cs-userProfileComponent__profileFollowersCounter cs-userProfileComponent__profileFollowersAfterCounter">{{getFollowersCountWithOfferQuantity()}}</div> 
          </div>
          </div>
        </div>
        <div class="cs-userProfileComponent__addToCart cs-formSubmitButton" v-on:click="onSubmit()">
          {{dictionary.buyNowTheOffer}}
        </div>
      </div>
      <UserPrivateComponent :isUserPrivate="isUserPrivate()" :offer="offer" :dictionary="dictionary" :user="userInfo" 
      @onWrongUsername="returnToFormStep()" @closeComponent="$emit('closeComponent')" 
      @retry="scrapeUser" @cancel="returnToFormStep()"></UserPrivateComponent>
      <OfferAddedToCart :dictionary="dictionary" :isShown="steps.isAddToCartSuccess" @closeComponent="$emit('closeComponent')" ></OfferAddedToCart>
    </div>
  </template>
  
  <script>
  import axios from "axios";
import { API2, SERVICE_TYPE } from '@/assets/js/constants';
import DefaultComponent from "./DefaultComponent.vue";
import DefaultHeader from "./DefaultHeader.vue";
import LoaderComponent from "./LoaderComponent.vue";
import UserPrivateComponent from "./UserPrivateComponent.vue";
import OfferAddedToCart from "./OfferAddedToCart.vue";
import { formatQuantityToLocale } from '@/assets/js/formatUtils';
import { addToCart } from '@/assets/js/formUtils';
  export default {
    name: "UserProfileComponent",
    props: ["offer", "dictionary"],
    emits: ["closeComponent"],
    data: function () {
        return {
            userInfo: {
                username: "",
                profilePic: "",
                followers: 0,
                isPrivate: false
            },
            steps:{
              isLoading: false,
              isForm: true,
              isProfileInfo: false,
              userNotFound: false,
              isAddToCartSuccess: false
            },
            error: {
              value: false,
              message: ""
            }
        };
    },
    methods: {
        formatQuantityToLocale: formatQuantityToLocale,
        async scrapeUser(username) {
          this.resetUserInfo();
          this.userInfo.username = username;
          this.resetErrorsStatus();
          this.steps.isForm = false;
          this.toggleLoader();
            if (this.offer.sliderID == SERVICE_TYPE.igUser) {
                await this.scrapeIgUser(username);
            }
            else if (this.offer.sliderID == SERVICE_TYPE.tkUser) {
                await this.scrapeTkUser(username);
            }
            this.toggleLoader();
            if(!this.isUserPrivate() && !this.steps.userNotFound){
              this.toggleProfileInfoStep();
            }  
            if(this.steps.userNotFound){
              this.toggleFormStep();
            }
        },
        async scrapeIgUser(username) {
            try {
                return axios.post(API2.url + API2.igUserEndpoint, {
                    user: username
                }).then(res => {
                  if(!this.isUserNotFound(res.data)){
                    this.fillUserInfo(res.data.username, res.data.profilePic, res.data.followers, res.data.isPrivate);
                  } else {
                    this.setUserNotFoundError();
                  }
                    
                });
            }
            catch (err) {
                console.log(err);
            }
        },
        async scrapeTkUser(username) {
            try {
                return axios.post(API2.url + API2.tkUserEndpoint, {
                    user: username
                }).then(res => {
                  if(!this.isUserNotFound(res.data)){
                    this.fillUserInfo(res.data.username, res.data.avatar, res.data.followers, res.data.isPrivate);
                  } else {
                    this.setUserNotFoundError();
                  }
                    
                });
            }
            catch (err) {
                console.log(err);
            }
        },
        fillUserInfo(username, profilePic, followers, isPrivate) {
            this.userInfo.username = username;
            this.userInfo.profilePic = profilePic;
            this.userInfo.followers = followers;
            this.userInfo.isPrivate = isPrivate;
        },
        toggleLoader(){
          this.steps.isLoading = !this.steps.isLoading;
        },
        toggleFormStep(){
          this.steps.isForm = !this.steps.isForm;
        },
        toggleProfileInfoStep(){
          this.steps.isProfileInfo = !this.steps.isProfileInfo;
        },
        getFollowersCountWithOfferQuantity(){
          return Number.parseInt(this.userInfo.followers) + Number.parseInt(this.offer.serviceQuantity);
        },
        isUserPrivate(){
          return this.userInfo.isPrivate;
        },
        isUserNotFound(response){
          if(response == {} || response.err) {
            this.steps.userNotFound = true;
            return true;
          }
          return false;
        },
        returnToFormStep(){
          this.resetUserInfo();
          this.resetErrorsStatus();
          this.steps.isProfileInfo = false;
          this.toggleFormStep();
        },
        setUserNotFoundError(){
          this.error.value = true;
          this.error.message = this.dictionary.userNotFound;
        },
        resetErrorsStatus(){
          this.error.value = false;
          this.error.message = "";
          this.steps.userNotFound = false;
        },
        resetUserInfo(){
          this.userInfo.username = "";
          this.userInfo.profilePic = "";
          this.userInfo.followers = 0;
          this.userInfo.isPrivate = false;
        },
        async onSubmit(){
          this.toggleLoader();
          this.toggleProfileInfoStep();
          await addToCart(this.offer._id, this.userInfo.username, this.userInfo.followers).then(res => {
            if(res.data.error){
              this.toggleLoader();
              this.onAddToCartError();
              this.toggleProfileInfoStep();
            } else {
              this.toggleLoader();
              this.onAddToCartSuccess();
            }
          }).catch(() => {
            this.toggleLoader();
            this.toggleProfileInfoStep();
            this.onAddToCartError();
          });
        },
        onAddToCartSuccess(){
          this.steps.isAddToCartSuccess = true;
        },
        onAddToCartError(){
          this.error.value = true;
          this.error.message = this.dictionary.addToCartError;
        }
    },
    components: { DefaultComponent, LoaderComponent, UserPrivateComponent, OfferAddedToCart, DefaultHeader }
}
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "@/assets/scss/form.scss";
    .cs-userProfileComponent__{
      &header {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }

      &offerQuantity {
        grid-column: 1 / span 2;
        grid-row: 1;
        color: #7762EF;
        font-size: 22px;
        font-weight: 700;
      }

      &close {
        grid-column: 2;
        grid-row: 1;
        justify-self: end;
        cursor: pointer;
      }

      &service{
        &Name{
          color: #7762EF;
          font-size: 22px;
          font-weight: 700;
        }
      }
      
      &info {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        column-gap: 20px;
      }

      &profilePic{
        width: 100px;
        height: 100px;
        border-radius: 25px;

        &Container{
          text-align: right;
          grid-column: 1;
          grid-row: 1 / span 2;
        }
      }


      &profileUsername{
        grid-column: 2;
        grid-row: 1;
        font-weight: 700;
        font-size: 18px;
        color: #C98CE5;
        display: flex;
        justify-content: center;
        align-items: flex-end;
      }

      &wrongUsernameQuestion {
        grid-column: 2;
        grid-row: 2;
        font-weight: 400;
        font-size: 12px;
        color: #123F49;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      &profileFollowers{
        grid-column: 1 / span 2;
        display: grid;
        grid-template-columns: 1fr 1fr;

        &Label{
          font-weight: 700;
          font-size: 14px;
          margin-bottom: 10px;
        }

        &Counter{
          font-weight: 700;
          font-size: 14px;
          padding: 5px 20px;
          border-radius: 25px;
          border-width: 3px;
          border-style: solid;
        }
      }

      &profileFollowersBefore{
        grid-column: 1;
        grid-row: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &Label, &Counter{
          color: #F15B65;
        }

        &Counter{
          border-color: #F15B65;
        }
      }

      &profileFollowersAfter{
        grid-column: 2;
        grid-row: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &Label, &Counter{
          color: #61CE70;
        }

        &Counter{
          border-color: #61CE70;
        }
      }
    }
  </style>
  